// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharedPostEmailStatsButton = require("./SharedPostEmailStatsButton.bs.js");
let MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql = require("../../../__generated__/MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.bs.js");

let convertFragment = MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

let SharedPropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MySharedPostsWidgetListItemSharedProperty(props) {
  let sharedProperty = RescriptRelay_Fragment.useFragment(MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, props.sharedProperty);
  let match = React.useState(() => false);
  let setIsExpanded = match[1];
  let isExpanded = match[0];
  let match$1 = sharedProperty.contacts;
  let contacts;
  if (match$1 !== undefined) {
    let edges = match$1.edges;
    contacts = edges !== undefined ? Stdlib_Array.keepSome(Stdlib_Array.keepSome(edges).map(c => c.node)) : [];
  } else {
    contacts = [];
  }
  let firstContact = Stdlib_Array.findMap(contacts, c => {
    switch (c.__typename) {
      case "SharingContactClientContactV5" :
        return c;
      case "SharingContactFreshContactV5" :
      case "__unselected" :
        return contacts[0];
    }
  });
  let contactToDisplayString = c => {
    switch (c.__typename) {
      case "SharingContactClientContactV5" :
        let lastName = c.lastName;
        let firstName = c.firstName;
        if (lastName !== undefined) {
          return firstName + ` ` + lastName;
        } else {
          return firstName;
        }
      case "SharingContactFreshContactV5" :
        return Scalars.EmailAddress.toString(c.email);
      case "__unselected" :
        return "";
    }
  };
  let otherContacts = contacts.filter(c => {
    if (firstContact === undefined) {
      return true;
    }
    switch (firstContact.__typename) {
      case "SharingContactClientContactV5" :
        switch (c.__typename) {
          case "SharingContactClientContactV5" :
            return firstContact.databaseId !== c.databaseId;
          case "SharingContactFreshContactV5" :
          case "__unselected" :
            return true;
        }
      case "SharingContactFreshContactV5" :
        switch (c.__typename) {
          case "SharingContactFreshContactV5" :
            return firstContact.databaseId !== c.databaseId;
          case "SharingContactClientContactV5" :
          case "__unselected" :
            return true;
        }
      case "__unselected" :
        return true;
    }
  });
  let match$2 = sharedProperty.propertyLocation;
  let tmp;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = `Hidden Address, ` + match$2.locationDisplay;
        break;
      case "PropertyLocationWithVisibleAddress" :
        tmp = match$2.address + `, ` + match$2.locationDisplay;
        break;
      case "__unselected" :
        tmp = null;
        break;
    }
  } else {
    tmp = null;
  }
  let tmp$1;
  if (isExpanded) {
    let len = otherContacts.length;
    tmp$1 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: len !== 1 ? (
            len !== 0 ? JsxRuntime.jsx("div", {
                children: otherContacts.map((c, index) => JsxRuntime.jsxs("span", {
                  children: [
                    index !== 0 ? (
                        index !== 1 ? ", " : "and "
                      ) : null,
                    contactToDisplayString(c)
                  ]
                })),
                className: "flex flex-row space-x-1 text-gray-500"
              }) : null
          ) : contactToDisplayString(otherContacts[0]),
        className: ""
      }),
      className: "col-span-12"
    });
  } else {
    tmp$1 = null;
  }
  let match$3 = sharedProperty.property;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Link, {
                href: "/shared-property/" + sharedProperty.databaseId,
                className: "font-semibold",
                children: tmp
              }),
              JsxRuntime.jsx("div", {
                children: "Shared with " + Stdlib_Option.getOr(Stdlib_Option.map(firstContact, contactToDisplayString), "-") + (
                  otherContacts.length !== 0 ? " and " : ""
                ),
                className: "text-gray-500 mt-1"
              }),
              otherContacts.length !== 0 ? JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                    onClick: param => setIsExpanded(currentState => !currentState),
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        otherContacts.length !== 1 ? otherContacts.length.toString() + " other contacts" : " 1 other contact",
                        JsxRuntime.jsx("span", {
                          children: JsxRuntime.jsx(IconV5.make, {
                            icon: isExpanded ? "arrow-up" : "arrow-down",
                            size: 10
                          }),
                          className: "inline-flex pl-2"
                        })
                      ]
                    })
                  }),
                  className: "mt-2"
                }) : null,
              tmp$1
            ]
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(Stdlib_Option.map(sharedProperty.createdAt, v => DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(v)), "MM/dd/yyyy")), ""),
            className: "mt-2 md:mt-0"
          })
        ],
        className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          match$3 !== undefined ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: "/properties/" + match$3.id,
              size: "small",
              children: "View Property"
            }) : null,
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            href: "/shared-property/" + sharedProperty.databaseId,
            size: "small",
            children: "View Shared Post"
          }),
          JsxRuntime.jsx(SharedPostEmailStatsButton.make, {
            sharedMessageId: sharedProperty.databaseId
          })
        ],
        className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end items-center pt-2 md:pt-0"
      })
    ],
    className: "grid grid-cols-12 gap-2 py-4 border-t"
  });
}

let make = MySharedPostsWidgetListItemSharedProperty;

exports.SharedPropertyFragment = SharedPropertyFragment;
exports.make = make;
/* react Not a pure module */
